import ProductCard from '@stories/Elements/Cards/ProductCard/ProductCard';
import Button from '@stories/Elements/Forms/Buttons/Button';
import React from 'react';
import { ProductListStyles } from './ProductList.styles';

export interface ProductListItemsGroupedProps {
  groupedProducts: GroupedProductsViewModel[];

  translations: Record<string, string | null>;

  onLoadMore: (key: string, value: string[]) => void;
  pageSize: number;
  value: string[];
}

const ProductListItemsGrouped: React.VFC<ProductListItemsGroupedProps> = (props) => {
  const handleOnMore = (model: GroupedProductsViewModel): void => {
    const existingIndex = props.value.findIndex((x) => x.startsWith(model.nodeId.toString()));

    if (existingIndex === -1) {
      props.onLoadMore('categoryPageNumber', [...props.value, `${model.nodeId}-2`]);
      return;
    }

    const existingPageIndex = parseInt(props.value[existingIndex].split('-')[1], 10);
    props.value[existingIndex] = `${model.nodeId}-${existingPageIndex + 1}`;

    props.onLoadMore('categoryPageNumber', [...props.value]);
  };

  const handleLoadAll = (model: GroupedProductsViewModel): void => {
    const existingIndex = props.value.findIndex((x) => x.startsWith(model.nodeId.toString()));
    const maxPageIndex = Math.ceil(model.productCount / props.pageSize);

    if (existingIndex === -1) {
      props.onLoadMore('categoryPageNumber', [...props.value, `${model.nodeId}-${maxPageIndex}`]);
      return;
    }

    props.value[existingIndex] = `${model.nodeId}-${maxPageIndex}`;

    props.onLoadMore('categoryPageNumber', [...props.value]);
  };

  const getCountText = (model: GroupedProductsViewModel): string | undefined => {
    const patt = /\[\[(.)\]\]/;
    const resString = props.translations['custom.showingxproducts'];

    return resString?.replace(patt, `${model.products.length}/${model.productCount}`);
  };

  return (
    <>
      {props.groupedProducts.map((x) => (
        <ProductListStyles.Group key={x.nodeId} data-scroll-hook={x.nodeId}>
          <ProductListStyles.GroupHeading>
            <h2>{x.categoryName}</h2>
          </ProductListStyles.GroupHeading>

          <ProductListStyles.ProductList>
            {x.products.map((p) => (
              <ProductCard
                key={p.agilityId}
                product={p}
                buttonText={props.translations['custom.products.view'] || ''}
              />
            ))}
          </ProductListStyles.ProductList>

          <ProductListStyles.GroupFooter>
            <h3>{getCountText(x)}</h3>

            {x.canLoadMore ? (
              <ProductListStyles.GroupButtons>
                <Button
                  theme="black"
                  size="small"
                  text={props.translations['custom.loadmore'] || ''}
                  onClick={() => handleOnMore(x)}
                />
                <Button
                  theme="black"
                  size="small"
                  text={props.translations['custom.loadall'] || ''}
                  onClick={() => handleLoadAll(x)}
                />
              </ProductListStyles.GroupButtons>
            ) : null}
          </ProductListStyles.GroupFooter>
        </ProductListStyles.Group>
      ))}
    </>
  );
};

export default ProductListItemsGrouped;
